import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { ArrowRightV2SvgComponent } from '@uc/shared/svg';

@Component({
	selector: 'uc-advice-category-card',
	templateUrl: './advice-category-card.component.html',
	imports: [RouterLink, ArrowRightV2SvgComponent, NgClass],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdviceCategoryCardComponent {
	categoryName = input.required<string>();
	articleCount = input.required<number>();
	categoryDesc = input.required<string>();
	categorySlug = input.required({
		transform: (slug: string) => `/advice/${slug}`,
	});
	isLast = input.required<boolean>();

	articleCountText = computed(() => {
		const count = this.articleCount();
		return `${count} ${count > 1 ? 'articles' : 'article'}`;
	});
}
